<script>
import BasePopup from '../../BasePopup.vue';

export default {
  name: 'TaskViewInfoPopup',
  components: { BasePopup },
  data() {
    return {
      isOpened: false,
    };
  },
  methods: {
    open() {
      this.isOpened = true;
    },
  },
};
</script>

<template lang="pug">
BasePopup(v-if="isOpened" @close="isOpened = false" :zIndex="9000")
  .info
    .info-header Справка
    .info-container
      .info-paragraph
        .info-regular В данном разделе вы можете гибко настраивать поиск ваших задач.
      .info-paragraph
        .info-regular Автор — фильтр, позволяющий настроить поиcк по создателям проекта.
      .info-paragraph
        .info-regular Ответственный — список пользователей, которые назначены в зачах ответственными за выпонение на данный момент.
      .info-paragraph
        .info-regular Участник — пользователь, который выполнял или будет выпонять работу в задаче, но не является ответственным.
</template>

<style scoped lang="scss">
.info {
  display: flex;
  flex-direction: column;
  gap: 26px;
  width: 459px;
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.info-header {
  display: flex;
  color: rgba(35, 34, 38, 1);
  font-family: Geometria, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.info-paragraph {
  display: flex;
}

.info-regular {
  color: rgba(30, 49, 71, 1);
  font-family: Geometria, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.info-subtitle {
  color: rgba(51, 161, 251, 1);
  font-family: Geometria, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
</style>
